import ProductConfig from './ProductConfig';

export default ProductConfig;
